export class ServiceData {
    page: number = 0;
    pageSize: number = 0;
    pageIndex: number = 0;
    totalRecords: number = 0;
    loadingValue: boolean = false;
}
